// PeriodBuyReport.js
// Component for the Period Buy Report

// Imports
import React from 'react';
import PropTypes from 'prop-types';
import ReportCard from './ReportCard';
import OrderSelect from './OrderSelect';
import dateFormat from 'dateformat';

// Component Class
// Shows Period Buy Report Card
class PeriodBuyReport extends React.Component {
  // Constructor
  constructor(props) {
    super(props);

    var defaultOrders = this.getDefaultOrders(props);
    this.state = {
      startOrder: defaultOrders.startOrder,
      endOrder: defaultOrders.endOrder,
    }
  }

  // Returns the filename for the downloaded report
  getFilename = () => {
    var sDate = this.state.startOrder && this.state.startOrder.dateClosed ? new Date(this.state.startOrder.dateClosed) : new Date();
    var eDate = this.state.endOrder && this.state.endOrder.dateClosed ? new Date(this.state.endOrder.dateClosed) : new Date();
    var startDateStr = dateFormat(sDate, "yyyy.mm.dd");
    var endDateStr = dateFormat(eDate, "yyyy.mm.dd");
    return "Carlinhos_Compras_Periodo_" + startDateStr + "_a_" + endDateStr + ".pdf"
  }

  // Returns the processed report object
  getReport = () => {
    return this.props.report.getPeriodBuyReport(this.state.startOrder, this.state.endOrder, this.props.orders);
  }

  // Returns the default start and end orders
  getDefaultOrders = (props) => {
    // Default to the first element in the archive for the current month, or the current open order
    var orders = props.orders.archive.slice();
    orders.push(props.orders.current);
    orders.reverse(); // So it's ordered from newest to oldest like OrderSelect

    var startOrder = orders.length > 0 ? orders[0] : null;
    var endOrder = orders.length > 0 ? orders[0] : null;

    if (startOrder) {
      // Find the first order of the current month
      var currentDate = startOrder.dateClosed ? new Date(startOrder.dateClosed) : new Date();
      var currentMonth = currentDate.getMonth();
      var currentYear = currentDate.getFullYear();

      for (var i = 0; i < orders.length; i++) {
        var orderDate = orders[i].dateClosed ? new Date(orders[i].dateClosed) : new Date();
        if (orderDate.getMonth() === currentMonth && orderDate.getFullYear() === currentYear) {
          startOrder = orders[i]; // Keep pushing back to find the earliest in the month
        }
        else
          break; // Since it's ordered newest to oldest, stop when the month changes
      }
    }

    return { startOrder, endOrder };
  }

  setStartOrder = (order) => {
    this.setState({ startOrder: order });
  }

  setEndOrder = (order) => {
    this.setState({ endOrder: order });
  }

  // Renders Component
  render() {
    return (
      <ReportCard
        title="Resumo de Compras por Período"
        description="Lista de produtos a comprar em cada dia e totalizado no período."
        getReport={this.getReport}
        getFilename={this.getFilename}
      >
        <center>
          <div style={{ marginBottom: '10px' }}>
            Início: <OrderSelect orders={this.props.orders} selected={this.state.startOrder} setOrder={this.setStartOrder} />
          </div>
          <div>
            Fim: <OrderSelect orders={this.props.orders} selected={this.state.endOrder} setOrder={this.setEndOrder} />
          </div>
        </center>
        <br />
      </ReportCard>
    );
  }
}

// Required Properties
PeriodBuyReport.propTypes = {
  report: PropTypes.object.isRequired,
  orders: PropTypes.object.isRequired,
}

// Exports
export default PeriodBuyReport;



// WEBPACK FOOTER //
// ./src/components/ReportView/PeriodBuyReport.js